// Module
var code = "<div class=\"connect-container\" page-tracker=\"discussions/connect\"> <ecv-connect redirect-to=\"connectVm.redirectTo\"></ecv-connect> </div> ";
// Exports
var _module_exports = code;;
var path = 'app/common/createDiscussion/components/connectPage/connect-page.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;